import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
export const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const scrollToSection = (id: string) => {
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(id);
        element?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(id);
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };
  return <header className="fixed top-0 left-0 right-0 bg-white z-50 px-4 sm:px-6 lg:px-8 h-[72px] shadow-sm" data-id="element-106">
      <div className="flex justify-between items-center max-w-7xl mx-auto h-full" data-id="element-107">
        <button onClick={() => navigate('/')} className="text-xl sm:text-2xl lg:text-3xl font-serif tracking-wide text-[#486878] hover:text-[#2c5aa0] transition-colors" data-id="element-108">
          Moonstone Events
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden md:block" data-id="element-109">
          <ul className="flex gap-8 lg:gap-10 items-center" data-id="element-110">
            <li data-id="element-111">
              <button onClick={() => scrollToSection('intro')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors text-base leading-none" data-id="element-112">
                Home
              </button>
            </li>
            <li data-id="element-113">
              <button onClick={() => scrollToSection('about')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors text-base leading-none" data-id="element-114">
                About
              </button>
            </li>
            <li data-id="element-115">
              <button onClick={() => scrollToSection('services')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors text-base leading-none" data-id="element-116">
                Services
              </button>
            </li>
            <li data-id="element-117">
              <button onClick={() => scrollToSection('portfolio')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors text-base leading-none" data-id="element-118">
                Portfolio
              </button>
            </li>
            <li data-id="element-119">
              <button onClick={() => scrollToSection('contact')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors text-base leading-none" data-id="element-120">
                Contact
              </button>
            </li>
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-[#486878] p-2 hover:text-[#2c5aa0] transition-colors" aria-label="Toggle menu" data-id="element-121">
          {mobileMenuOpen ? <X size={24} data-id="element-122" /> : <Menu size={24} data-id="element-123" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && <nav className="md:hidden mt-0 pb-4 border-t border-gray-200 bg-white" data-id="element-124">
          <ul className="flex flex-col gap-1 pt-2" data-id="element-125">
            <li data-id="element-126">
              <button onClick={() => scrollToSection('intro')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors w-full text-left px-4 py-3 text-base" data-id="element-127">
                Home
              </button>
            </li>
            <li data-id="element-128">
              <button onClick={() => scrollToSection('about')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors w-full text-left px-4 py-3 text-base" data-id="element-129">
                About
              </button>
            </li>
            <li data-id="element-130">
              <button onClick={() => scrollToSection('services')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors w-full text-left px-4 py-3 text-base" data-id="element-131">
                Services
              </button>
            </li>
            <li data-id="element-132">
              <button onClick={() => scrollToSection('portfolio')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors w-full text-left px-4 py-3 text-base" data-id="element-133">
                Portfolio
              </button>
            </li>
            <li data-id="element-134">
              <button onClick={() => scrollToSection('contact')} className="text-[#486878] hover:text-[#2c5aa0] transition-colors w-full text-left px-4 py-3 text-base" data-id="element-135">
                Contact
              </button>
            </li>
          </ul>
        </nav>}
    </header>;
};